import { createClient as createSupabaseClient } from '@supabase/supabase-js';
import type { SupabaseClient } from '@supabase/supabase-js';
import type { Database } from '@/lib/database.types';
import { getAccessToken } from '@/utils/supabase/token-manager';

// Browser Supabase client. The session cookie is HttpOnly (server-only), so this
// client cannot read it. Instead it uses the `accessToken` provider: supabase-js
// pulls a short-lived token from the token-manager for every REST request and
// Realtime heartbeat. As a consequence `supabase.auth.*` is unavailable here —
// auth mutations happen via server actions, and identity is read from
// /api/auth/user. Singleton so all consumers share one Realtime socket.
let client: SupabaseClient<Database> | null = null;

export function createClient(): SupabaseClient<Database> {
  if (client) return client;

  client = createSupabaseClient<Database>(
    process.env.NEXT_PUBLIC_SUPABASE_URL!,
    process.env.NEXT_PUBLIC_SUPABASE_PUBLISHABLE_KEY!,
    {
      accessToken: () => getAccessToken(),
      realtime: {
        // postgres_changes joins do real server-side setup (RLS policy reads)
        // and can exceed the 10s default — every retry then aborts too early,
        // permanently and silently leaving the page without live updates.
        timeout: 30_000,
      },
    }
  );

  return client;
}

export const getBrowserClient = createClient;
